import { NgModule } from '@angular/core';
import { ZuperMediaWatcherService } from './media-watcher.service';

@NgModule({
    providers: [
        ZuperMediaWatcherService
    ]
})
export class ZuperMediaWatcherModule
{
    /**
     * Constructor
     */
    constructor(private _zuperMediaWatcherService: ZuperMediaWatcherService)
    {
    }
}
